import { Component, Story, Knobs } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  disabled: { default: false, editor: 'checkbox' },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A clickable icon',
  coreComponent_v3: {
    html: `<tag3-clickable name="1"{{...knobs}}>
  <tag3-icon icon="Home"></tag3-icon>
</tag3-clickable>`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Clickable name="1"{{...knobs}}>
  <Tag3Icon icon="Home"/>
</Tag3Clickable>`,
    knobs: PlaygroundStoryKnobs,
  },
};

export const TagClickableDocs: Component = {
  type: 'component',
  name: 'clickable',
  description: 'Renders a clickable element',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the clickable element',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Whether the clickable element is disabled or not',
      type: 'boolean',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'buttonClick',
      description: 'Triggers when the button is clicked',
      parameters: [],
    },
  ],
  methods: [],
  stories: [PlaygroundStory],
};
